import createApiStoreCreator from './createApiStoreCreator'
import ncpApi from './ncpApi'
import tdealApi from './tdealApi'
import tdealApiV2 from './tdealApiV2'
import partnerAdminApi from './partnerAdminApi'
import clickRewardApi from './clickRewardApi'

const createNcpApiStore = createApiStoreCreator(ncpApi)
const createTDealApiStore = createApiStoreCreator(tdealApi)
const createTDealApiV2Store = createApiStoreCreator(tdealApiV2)
const createPartnerAdminApiStore = createApiStoreCreator(partnerAdminApi)
const createClickRewardApiStore = createApiStoreCreator(clickRewardApi)

export {
  ncpApi as default,
  ncpApi,
  tdealApi,
  tdealApiV2,
  createNcpApiStore,
  createTDealApiStore,
  createTDealApiV2Store,
  createPartnerAdminApiStore,
  createClickRewardApiStore
}
